import {
  EstimatedRefundValuesDto,
  EstimatedRefundValuesItemDto,
  EstimatedRefundValuesItemModel,
  EstimatedRefundValuesModel,
} from '../types/estimated-refund-values'
import { transformCurrencyAmountDto } from './currency-amount'

export const transformEstimatedRefundValuesItem = (
  item: EstimatedRefundValuesItemDto,
): EstimatedRefundValuesItemModel => ({
  title: item.title,
  value: transformCurrencyAmountDto(item.value),
  type: item.type,
})

export const transformEstimatedRefundValuesDto = (
  estimatedRefundValuesDto: EstimatedRefundValuesDto,
): EstimatedRefundValuesModel => ({
  totalRefund: transformEstimatedRefundValuesItem(estimatedRefundValuesDto.total_refund),
  deductedRefund: {
    ...transformEstimatedRefundValuesItem(estimatedRefundValuesDto.deducted_refund),
    deductibles: estimatedRefundValuesDto.deducted_refund.deductibles.map(deductible =>
      transformEstimatedRefundValuesItem(deductible),
    ),
  },
  isConverted: estimatedRefundValuesDto.is_converted,
})
